
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/bulkinventory",
      function () {
        return require("private-next-pages/products/bulkinventory.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/bulkinventory"])
      });
    }
  